import React, { useState } from "react";
import { ChevronDown, DollarSign, Receipt, TrendingUp, XCircle, Zap } from "lucide-react";

import { Skeleton } from "@/components/ui/skeleton";

const fmtMoney = (v) =>
  `R$ ${Number(v || 0).toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
const fmtNum = (v) => Number(v || 0).toLocaleString("pt-BR");

// Resumo para telas onde o painel lateral não cabe (notebook estreito, tablet,
// celular): mesma informação, deitada e recolhível, acima da lista. Sem isto o
// lojista em tela menor simplesmente perderia o faturamento de vista.
export default function ResumoFaixa({ stats, grupos, automacao, filtrado, onAbrirGrupo, carregando = false }) {
  const [aberto, setAberto] = useState(false);
  const comPedido = (grupos || []).filter((g) => g.count > 0);

  // Até o 1º resumo chegar: faixa piscando em vez de "R$ 0,00" (25/10/2026).
  if (!stats && carregando) {
    return (
      <div className="xl:hidden rounded-xl border bg-card shadow-sm mb-4 px-4 py-3 flex items-center gap-3"
        data-e2e="resumo-faixa-carregando" aria-busy="true" aria-label="Carregando">
        <Skeleton className="w-4 h-4 rounded-full shrink-0" />
        <div className="space-y-1.5"><Skeleton className="h-2.5 w-20" /><Skeleton className="h-5 w-32" /></div>
        <Skeleton className="ml-auto h-8 w-20 hidden sm:block" />
      </div>
    );
  }

  return (
    <div className="xl:hidden rounded-xl border bg-card shadow-sm mb-4 overflow-hidden" data-e2e="resumo-faixa">
      <button
        type="button"
        onClick={() => setAberto((a) => !a)}
        className="w-full flex items-center gap-3 px-4 py-3 text-left"
      >
        <DollarSign className="w-4 h-4 text-emerald-500 shrink-0" />
        <div className="min-w-0">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground leading-none">
            Faturamento {filtrado ? "(filtrado)" : ""}
          </p>
          <p className="text-xl font-black text-emerald-600 dark:text-emerald-400 leading-tight">
            {fmtMoney(stats?.faturamentoTotal)}
          </p>
        </div>
        <div className="ml-auto flex items-center gap-4">
          <div className="text-right hidden sm:block">
            <p className="text-[10px] uppercase tracking-wider text-muted-foreground leading-none">Ticket</p>
            <p className="text-sm font-bold leading-tight">{fmtMoney(stats?.ticketMedio)}</p>
          </div>
          <ChevronDown className={`w-4 h-4 text-muted-foreground transition-transform ${aberto ? "rotate-180" : ""}`} />
        </div>
      </button>

      {aberto ? (
        <div className="px-4 pb-3 space-y-3 border-t pt-3">
          {automacao && automacao.basePedidos > 0 ? (
            <div className="flex items-center gap-1.5 rounded-lg bg-emerald-500/10 border border-emerald-500/30 px-3 py-2">
              <Zap className="w-3.5 h-3.5 text-emerald-500 shrink-0" />
              <span className="text-xs">
                <strong className="text-emerald-600 dark:text-emerald-400">
                  {Math.round(automacao.pctPedidos)}%
                </strong>{" "}
                dos pedidos entraram sozinhos pelo Núcleo
              </span>
            </div>
          ) : null}
          <div className="flex flex-wrap gap-4">
            <div className="flex items-center gap-1.5">
              <TrendingUp className="w-3.5 h-3.5 text-orange-500" />
              <span className="text-xs text-muted-foreground">Ticket médio</span>
              <span className="text-sm font-bold">{fmtMoney(stats?.ticketMedio)}</span>
            </div>
            <div className="flex items-center gap-1.5">
              <Receipt className="w-3.5 h-3.5 text-muted-foreground" />
              <span className="text-xs text-muted-foreground">Pedidos</span>
              <span className="text-sm font-bold">{fmtNum(stats?.total)}</span>
            </div>
            <div className="flex items-center gap-1.5">
              <XCircle className="w-3.5 h-3.5 text-red-500" />
              <span className="text-xs text-muted-foreground">Cancelados</span>
              <span className="text-sm font-bold text-red-500">{fmtNum(stats?.cancelado)}</span>
            </div>
          </div>
          <div className="flex gap-2 overflow-x-auto pb-1">
            {comPedido.map((g) => (
              <button
                key={g.key}
                type="button"
                onClick={() => onAbrirGrupo(g.key)}
                className="shrink-0 flex items-center gap-1.5 rounded-full border border-border px-3 h-8 text-xs font-semibold hover:bg-muted transition"
              >
                <span className={`w-2 h-2 rounded-full ${g.cor}`} />
                {g.label}
                <span className="font-black tabular-nums">{fmtNum(g.count)}</span>
              </button>
            ))}
            {comPedido.length === 0 ? (
              <span className="text-xs text-muted-foreground py-1.5">Nenhum pedido no período.</span>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
}
